import {Component, Input, OnInit} from '@angular/core';
import {ShoppingItem} from "@biletix/core/models/shopping-cart/shopping-item.model";
import {ShoppingUpsellItem} from "@biletix/core/models/shopping-cart/shopping-upsell-item.model";
import {environment} from "@biletix/env";
import {RouterService} from "@biletix/core/services/router.service";
import {ShoppingItemSeatInfo} from "@biletix/core/models/shopping-cart/shopping-item-seat-info.model";
import { from } from 'rxjs';
import { groupBy, map, mergeMap, reduce, toArray } from 'rxjs/operators';
import { EventRuleModalComponent } from '../../popups/event-rule-modal/event-rule-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { EventService } from '@biletix/core/services/event.service';
import {AbstractionComponent} from "@biletix/core/common/abstraction-component";

@Component({
    selector: 'btx-ticket-summary-item-new',
    templateUrl: './ticket-summary-item-new.component.html',
    styleUrls: ['./ticket-summary-item-new.component.scss'],
    standalone:false
})
export class TicketSummaryItemNewComponent extends AbstractionComponent implements OnInit {

    @Input("items") items: ShoppingItem[] = [];

    @Input() eventTickets: ShoppingItem[] = [];

    @Input() eventUpsells: ShoppingUpsellItem[] | undefined = [];

    @Input() digitalTicketLink?: string;

    @Input() invoiceLink?: string;

    @Input() isHomePrint: boolean = false;

    @Input() tffEvent: boolean = false;

    @Input() isLast: boolean = false;

    @Input() liveEventTokens: string[] = [];

    @Input() showLiveEventContainer: boolean = true;

    @Input()  liveEventDistributionLink?: string;

    firstItem: ShoppingItem | any;
    firstTicketItem!: ShoppingItem;
    upsellImageBasePath: string = environment.upsellImageBasePath;

    seatNumberList: { section: string, rowNo: string, seatNo: string, title: string, distributionTokens: string[] }[] = [];
    distributionTokens: string[] = [];
    showOnlyDistributionCodes: boolean = false;

    shoppingItemSeatInfoMap: Map<string, ShoppingItemSeatInfo[]>;

    eventRules?: string;

    constructor(private dialog: MatDialog,
                private routerService: RouterService,
                private eventService: EventService) {
        super();
        this.shoppingItemSeatInfoMap = new Map<string, ShoppingItemSeatInfo[]>();
    }

    ngOnInit(): void {  
        this.firstTicketItem = this.eventTickets[0];  
        this.showOnlyDistributionCodes = !!this.firstTicketItem?.showDistributionToken;

        this.getEventRules(this.firstTicketItem?.eventCode);

        this.initializeVariables();
    }

    initializeVariables() {




        from(this.eventTickets).pipe(map(item => item.seats), reduce((acc, value) => acc.concat(value), new Array<ShoppingItemSeatInfo>())).subscribe(seats => {

            this.setShoppingItemSeatInfoMap(seats);

            const tmpSeatNumberList: { section: string, rowNo: string,seatNo: string, title: string, distributionTokens: string[] }[] = [];
            for (let sinfo of this.shoppingItemSeatInfoMap.values()) { 
                const seatDistributionTokens = sinfo
                    .map(item => (item.distributionToken || '').trim())
                    .filter(token => !!token);
                tmpSeatNumberList.push({
                    title: `${sinfo[0].concessionName}(x${sinfo?.length ?? 0})`,
                    section: sinfo[0].blockName,
                    rowNo: sinfo?.filter(item => item.rowNo != "" ).map(item => item.rowNo ).join(","),
                    seatNo: sinfo?.filter(item => item.seatNo != "").map(item => item.seatNo).join(","), 
                    distributionTokens: seatDistributionTokens
                });
            }
            this.seatNumberList = tmpSeatNumberList;

            const distributionTokens = seats
                .map(item => (item.distributionToken || '').trim())
                .filter(token => !!token);
            this.distributionTokens = Array.from(new Set(distributionTokens));

        });


        /*
        this.seatNumberList = this.eventTickets.map(item => {
                const seats: ShoppingItemSeatInfo[] = item.seats;
                return {
                    title: `${seats[0].concessionName}(x${seats?.length ?? 0})`,
                    section: seats?.map(item => item.blockCode)
                        .join("-"),

                    rowNo: seats?.filter(item => item.rowNo != "" && item.seatNo != "")
                        .map(item => item.rowNo + "/" + item.seatNo)
                        .join(",")
                }
            }
        );
        */
    }


    setShoppingItemSeatInfoMap(items: ShoppingItemSeatInfo[]) {
        from(items)
            .pipe(
                groupBy(item => (item.concessionCode + "-" + item.blockCode)),
                mergeMap(group => group.pipe(toArray())),
                map(arr => {

                    let shoppingItemSeatInfo: ShoppingItemSeatInfo = arr[0];
                    const key = shoppingItemSeatInfo.concessionCode + shoppingItemSeatInfo.blockCode;
                    return { key: key, values: arr };
                }
                )
            ).subscribe(map => this.shoppingItemSeatInfoMap.set(map.key, map.values));
    }

    getShoppingItemsTotalPrice(): number {
        let totalPrice = 0;
        if (this.eventTickets && this.eventTickets.length > 0) {
            totalPrice += this.eventTickets.reduce((acc, cur) => acc + cur.totalPrice, 0);
        }
        return totalPrice;
    }

    getShoppingItemsTotalServicePrice(): number {
        let totalServicePrice = 0;
        if (this.eventTickets && this.eventTickets.length > 0) {
            totalServicePrice += this.eventTickets.reduce((acc, cur) => acc + cur.servicePrice, 0);
        }
        return totalServicePrice;
    }

    get ticketCount(): number {
        return this.eventTickets?.reduce((acc, cur) => acc + cur.seats.length, 0) ?? 0;
    }

    get performancePageLink(): string {
        return this.routerService.getPerformancePageUrl(this.firstTicketItem?.eventCode, this.firstTicketItem?.performanceCode);
    }

    isEventUpsellVisible(): boolean {
        return (this.eventUpsells && this.eventUpsells.length > 0) ?? false;
    }


    get totalUpsellCount(): number {
        return this.eventUpsells?.reduce((cur, prev) => prev.quantity + cur, 0) ?? 0;
    }


    /**
     *
     */
    isLinksVisible(): boolean {
        if (this.digitalTicketLink) {
            return true;
        }
        return false;
    }


    getEventRules(eventCode: string) {
        if (eventCode) {
            this.eventService
                .getEventRulesByEventCode(this.firstTicketItem.eventCode)
                .pipe(this.takeUntilDestroy())
                .subscribe(rules => this.eventRules = rules);
        }
    }

    isEventRulesVisible(): boolean {
        if (this.eventRules && this.eventRules.length > 0) {
            return true;
        }
        return false;
    }

    showEventRules() {
        this.dialog.open(EventRuleModalComponent,
            {
                hasBackdrop: true,
                width: '600px',
                role: 'dialog',
                data: this.eventRules
            }
        );
    }

    hasLiveToken(): boolean {
        return this.liveEventTokens.length > 0;

     }

     hasLiveEventLink(): boolean {
        return !!this.liveEventDistributionLink;
  
      }

}
